import Http from "./http";

export const getAdminProfileAPI = (data = {}) => {
  return Http.post("admin/profile", data);
};
